import { render } from "./FollowUpOrganization.vue?vue&type=template&id=230cfd02&scoped=true"
import script from "./FollowUpOrganization.vue?vue&type=script&lang=js"
export * from "./FollowUpOrganization.vue?vue&type=script&lang=js"

import "./FollowUpOrganization.vue?vue&type=style&index=0&id=230cfd02&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230cfd02"]])

export default __exports__